"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationLocale = void 0;
var ApplicationLocale = /** @class */ (function () {
    function ApplicationLocale() {
        this.code = '';
        this.description = '';
        this.isDefault = false;
    }
    return ApplicationLocale;
}());
exports.ApplicationLocale = ApplicationLocale;
